module.exports = __webpack_public_path__ + "img/bad.83c19427.png";